<template>
  <fragment>
    <div class="header" v-if="header">{{ header }}</div>
    <div class="item">
      <div class="relation">
        <div
          class="child-of"
          :class="[relation === 'child-of' ? 'selected' : '']"
          @click="updateTo('child-of')"
          :title="$t('CHILD_OF_TITLE')"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xl="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            viewBox="460 226 142 99"
            width="23"
            height="20"
          >
            <defs>
              <marker
                orient="auto"
                overflow="visible"
                markerUnits="strokeWidth"
                id="FilledArrow_Marker_ChildOf"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                viewBox="-4 -2 6 4"
                markerWidth="6"
                markerHeight="4"
                class="colored"
              >
                <g>
                  <path d="M -2.4 0 L 0 .9 L 0 -.9 Z" class="stroked filled" stroke-width="1" />
                </g>
              </marker>
            </defs>
            <g
              id="child-of"
              stroke-opacity="1"
              fill-opacity="1"
              stroke-dasharray="none"
              stroke="none"
              fill="none"
            >
              <line
                x1="534.2261"
                y1="271.70826"
                x2="542.2739"
                y2="282.29174"
                class="stroked"
                stroke-linecap="square"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <line
                x1="505.8982"
                y1="271.80237"
                x2="498.1018"
                y2="282.19763"
                class="stroked"
                stroke-linecap="square"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <circle
                cx="484"
                cy="301"
                r="18.5000295611851"
                class="stroked"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="10"
              />

              <circle
                cx="520"
                cy="253"
                r="18.5000295611851"
                class="stroked filled"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <circle
                cx="556.5"
                cy="301"
                r="18.5000295611851"
                class="stroked filled"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <line
                x1="575.1245"
                y1="254.27062"
                x2="597.3684"
                y2="282.5"
                marker-start="url(#FilledArrow_Marker_ChildOf)"
                class="stroked"
                stroke-linecap="square"
                stroke-linejoin="round"
                stroke-width="8"
              />
            </g>
          </svg>
        </div>

        <div
          class="sibling-of"
          :class="[relation === 'sibling-of' ? 'selected' : '']"
          @click="updateTo('sibling-of')"
          :title="$t('SIBLING_OF_TITLE')"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xl="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            viewBox="876 442 120 124"
            width="20"
            height="20"
          >
            <defs>
              <marker
                orient="auto"
                overflow="visible"
                markerUnits="strokeWidth"
                id="FilledArrow_Marker_Sibling"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                viewBox="-4 -2 6 4"
                markerWidth="6"
                markerHeight="4"
                class="colored"
              >
                <g>
                  <path d="M -2.4 0 L 0 .9 L 0 -.9 Z" class="stroked filled" stroke-width="1" />
                </g>
              </marker>
            </defs>

            <g
              id="sibling-of"
              stroke-opacity="1"
              fill-opacity="1"
              stroke-dasharray="none"
              stroke="none"
              fill="none"
            >
              <line
                x1="949.7261"
                y1="484.20826"
                x2="957.7739"
                y2="494.79174"
                class="stroked"
                stroke-linecap="square"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <line
                x1="921.3982"
                y1="484.3024"
                x2="913.6018"
                y2="494.69763"
                class="stroked"
                stroke-linecap="square"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <circle
                id="parent"
                cx="935.5"
                cy="465.5"
                r="18.5000295611851"
                class="stroked"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <circle
                id="ref"
                cx="899.5"
                cy="513.5"
                r="18.5000295611851"
                class="stroked filled"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <circle
                id="target"
                cx="972"
                cy="513.5"
                r="18.5000295611851"
                class="stroked filled"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="10"
              />
              <line
                id="rel"
                x1="945.1"
                y1="552.7836"
                x2="903.576"
                y2="552.7836"
                marker-start="url(#FilledArrow_Marker_Sibling)"
                class="stroked"
                stroke-linecap="square"
                stroke-linejoin="round"
                stroke-width="8"
              />
            </g>
          </svg>
        </div>

        <div
          v-for="direction in directions"
          :class="[direction.d]"
          :key="direction.d"
          @click="updateTo(direction.d)"
          :title="$t(`${direction.d.toUpperCase()}_TITLE`)"
        >
          <i class="icon" :class="[(direction.d === relation ? 'blue ' : '') + direction.i]" />
        </div>
        <div class="remove" :title="$t('DELETE', { thing: $tc('RELATION', 1) })">
          <i class="small red trash icon" @click="remove" />
        </div>
      </div>
    </div>
  </fragment>
</template>

<style lang="scss" scoped>
.relation {
  display: grid;
  grid-template-columns: 2fr 4fr 2fr 4fr 10px;
  gap: 1em;
  grid-template-areas:
    'structural-header positional-header positional-header positional-header remove'
    'child-of below below below remove'
    'child-of right-of nearest left-of .'
    'sibling-of above above above .'
    'sibling-of . . . .';

  .below {
    grid-area: below;
    display: flex;
    justify-content: center;
  }

  .above {
    grid-area: above;
    display: flex;
    justify-content: center;
  }

  .right-of {
    grid-area: right-of;
    display: flex;
    justify-content: end;
  }

  .nearest {
    display: flex;
    justify-content: center;
    grid-area: nearest;
  }

  .left-of {
    display: flex;
    justify-content: start;
    grid-area: left-of;
  }

  .remove {
    grid-area: remove;
  }

  .sibling-of {
    grid-area: sibling-of;
  }

  .child-of {
    grid-area: child-of;
  }

  .child-of,
  .sibling-of {
    display: flex;
    justify-content: start;

    .stroked {
      stroke: black;
    }
    .filled {
      fill: black;
    }
    .colored {
      color: black;
    }

    &.selected {
      .stroked {
        stroke: #2185d0;
      }
      .filled {
        fill: #2185d0;
      }
      .colored {
        color: #2185d0;
      }
    }
  }
}
</style>

<script>
// @flow
import Vue from 'vue'
import { Fragment } from 'vue-frag'

export default {
  name: 'TailRelationMenuFragment',
  props: ['relation', 'header'],
  components: {
    Fragment
  },

  data() {
    return {
      directions: [
        { d: 'nearest', i: 'bullseye' },
        { d: 'above', i: 'arrow down' },
        { d: 'below', i: 'arrow up' },
        { d: 'right-of', i: 'arrow left' },
        { d: 'left-of', i: 'arrow right' }
      ]
    }
  },

  methods: {
    updateTo(direction) {
      this.$emit('relation-update', direction)
    },
    remove() {
      this.$emit('relation-remove')
    }
  }
}
</script>
